import BasicItemsCard from './BasicItemsCard';

export default BasicItemsCard;
